import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { backspaceSharp } from 'ionicons/icons';
import { TranslateModule } from '@ngx-translate/core';
import { WordGuessLetterStateEnum } from '../interfaces/word-guess-letter-state.enum';

/*
 * German QWERTZ layout with the umlaut keys the puzzle actually uses. Ä/Ö/Ü are ordinary
 * letters here, never AE/OE/UE.
 */
export const WORD_GUESS_KEYBOARD_ROWS: string[][] = [
  ['Q', 'W', 'E', 'R', 'T', 'Z', 'U', 'I', 'O', 'P', 'Ü'],
  ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', 'Ö', 'Ä'],
  ['Y', 'X', 'C', 'V', 'B', 'N', 'M'],
];

@Component({
  selector: 'lib-app-word-guess-keyboard',
  templateUrl: './word-guess-keyboard.component.html',
  styleUrls: ['./word-guess-keyboard.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, IonButton, IonIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WordGuessKeyboardComponent {
  @Input() letterStates: { [letter: string]: WordGuessLetterStateEnum } = {};
  @Input() disabled = false;
  @Input() canSubmit = false;
  @Input() canDelete = false;

  @Output() letterPressed = new EventEmitter<string>();
  @Output() enterPressed = new EventEmitter<void>();
  @Output() deletePressed = new EventEmitter<void>();

  rows = WORD_GUESS_KEYBOARD_ROWS;

  constructor() {
    addIcons({ backspaceSharp });
  }

  letterState(letter: string): string {
    return this.letterStates[letter] || WordGuessLetterStateEnum.Empty;
  }

  onLetter(letter: string): void {
    if (this.disabled) {
      return;
    }

    this.letterPressed.emit(letter);
  }

  onEnter(): void {
    if (this.disabled || !this.canSubmit) {
      return;
    }

    this.enterPressed.emit();
  }

  onDelete(): void {
    if (this.disabled || !this.canDelete) {
      return;
    }

    this.deletePressed.emit();
  }
}
